<template>
  <v-layout row wrap>
    <v-flex xs12 v-if="event && event.title">
         <h1 class="headline">{{event.title}}</h1>
        <p class="title">Location: {{event.location}}</p>
        <p class="subheading" v-if="event.date">{{event.date | date}}</p>
        <p class="subheading" v-if="event.dateFrom">
            {{event.dateFrom | date}} - {{event.dateTo | date}}
        </p>
        <v-alert
            :value="alert.show"
            :type="alert.type"
            >
            {{alert.message}}
        </v-alert>
        <v-card color="light-green">
            <v-card-title primary-title>
                <div class="subheading">Participants (Total: {{comingParticipants.length}})
                    <span v-if="userEventData">
                        <v-btn disabled 
                                color="warning"
                                v-if="!userEventData">
                            You are not invited
                        </v-btn>
                        <v-btn color="success" 
                               v-else-if="userEventData.status === 'invited'"
                               v-on:click="joinEvent"
                               :loading="loading"
                               :disabled="loading">
                            Join
                        </v-btn>
                        <v-btn color="error" 
                                v-else-if="userEventData.status === 'coming'"
                                v-on:click="leaveEvent"
                                 :loading="loading"
                                :disabled="loading">
                            Leave
                        </v-btn>
                        <v-btn color="info" v-else-if="userEventData.status === 'left'">
                            You left the event
                        </v-btn>
                    </span>
                </div>
            </v-card-title>
            <v-card-text>
                 <v-chip v-for="(value, key) in comingParticipants">
                    <v-avatar class="teal">{{key + 1}}</v-avatar>
                    {{value.displayName}}
                </v-chip>
            </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-layout row wrap v-if="event && userData && userData.roles.admin">
            <v-flex xs12 sm6 md4 lg3>
                <EventGenerateTeams v-bind:event="event"></EventGenerateTeams>    
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 sm6 md4 lg3
                v-for="(value) in teams"
            >
            <v-card color="light-green" class="deep-purple">
                <v-card-title primary-title>
                    <div class="subheading">{{value.teamName}}  ({{value.color}}*)</div>
                </v-card-title>
                <v-list dense v-for="player in value.players">
                    <v-list-tile>
                    <v-list-tile-content>{{ player.displayName }}</v-list-tile-content>
                    </v-list-tile>
            </v-list>
            </v-card>
            </v-flex>
        </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { db } from '../services/firebase';

export default {
  name: 'EventDetails',
  props: ['id'],
  data () {
      return {
          subscribers: [],
          participants: [],
          teams: [],
          loading: false,
          alert: {
              show: false,
              message: '',
              type: 'error'
          }
      }
  },
  computed: { 
        invitedParticipants: function () {
            return this.participants.filter(participant => participant.status === 'invited');
        }, 
        comingParticipants: function () {
            return this.participants.filter(participant => participant.status === 'coming')
                .sort((a, b) => {
                    return a.joinedAt.seconds - b.joinedAt.seconds;
                });
        }, 
        userEventData: function () {
            const user = this.$store.state.userAuthData;
            return this.participants.find(participant => participant.participantId === user.uid);
        },
         userData () {
            return this.$store.state.userData;
        } 
  },
 firestore () {
    return {
      event: {
        ref: db.collection('events').doc(this.id),
        resolve: (data) => {
           // Binding Collections
          db.collection('event_templates')
            .doc(data.eventTemplateId).get
            this.$binding("subscribers", db.collection('event_templates')
            .doc(data.eventTemplateId).collection('subscribers'));
        },
      }
    }
  },
  mounted () {
     if (this.id) {
        // Binding Collections
        this.$binding("participants",db.collection('events')
          .doc(this.id).collection('participants'));
        
        // Binding Docs
        this.$binding("teams", db.collection('participations_teams')
          .where('eventId', '==', this.id));
     }
  },
  methods: {
     joinEvent: function() {
        this.loading = true;

        this.$firestore.participants.doc(this.userEventData['.key']).set({
            status: 'coming',
            joinedAt: new Date()
        }, {merge: true}).then(() => {
            if (this.comingParticipants.length > 15) {
                this.showAlert({
                    message: 'You joined this event as substitution!',
                    type: 'error'
                });
            }
            this.loading = false;
        }).catch(() =>{
            this.loading = false;
            this.showAlert({
                message: 'Error joining event!',
                type: 'error'
            });
        });
    },

    leaveEvent: function() {
        this.loading = true;

        this.$firestore.participants.doc(this.userEventData['.key']).set({
            status: 'left',
            leftAt: new Date()
        }, {merge: true}).then(() => {
            this.loading = false;
        }).catch(() =>{
            this.loading = false;
            this.showAlert({
                message: 'Error leaving event!',
                type: 'error'
            });
        });
    },

    showAlert(data) {
        this.alert.show = true;
        this.alert.message = data.message;
        this.alert.type = data.type;
    }
  }
}

</script>